import fieldNames from '../constants/field-names';
import buildLinkElement from '../../../helpers/build-link-element';
import buildLinkConfigFromFieldsValues from './build-link-config-from-fields-values';
import prepareLinkConfig from './prepare-link-config';

const buildLinkElementFromFieldsValues = (fieldsValues) => {
  const linkType = fieldsValues[fieldNames.LINK_TYPE];

  if (!linkType) {
    return null;
  }

  const linkConfig = buildLinkConfigFromFieldsValues(linkType, fieldsValues);
  const finalLinkConfig = prepareLinkConfig(linkType, linkConfig);

  return buildLinkElement(finalLinkConfig);
};

export default buildLinkElementFromFieldsValues;
